import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'pos-manager-confirm-modal',
  templateUrl: './pos-manager-confirm.modal.html',
  styleUrls: ['./pos-manager-confirm.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PosManagerConfirmModal {
  @Input() title: string;
  @Input() description: string;

  constructor(private readonly modalController: ModalController) {}

  cancel() {
    this.modalController.dismiss({ deleted: false });
  }

  ok() {
    this.modalController.dismiss({ deleted: true });
  }
}
